
import { BodyEvent, CarCard, CarEvent, FaceEvent, HumanCard, WatchList } from '@/api';
import { ObjectsSingleToMulti, ObjectsType } from '@/store/application/data.assets';
import { featuresModule } from '@/store/features';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { dataModule } from '@/store/data';

type EventWithType = (FaceEvent | BodyEvent | CarEvent) & { type: string };

@Options({
  name: 'VideoPlayerOverlayMeta'
})
export default class VideoPlayerOverlayMeta extends Vue {
  @Prop({ type: Object, required: true })
  readonly eventItem!: EventWithType;

  card: HumanCard | CarCard | null = null;
  watchLists: WatchList[] = [];

  get formattedFeatures() {
    return featuresModule.getFeatureProperties(this.eventItem.features, ObjectsSingleToMulti[this.eventItem.type] as ObjectsType);
  }

  async loadCard() {
    const id = this.eventItem?.matched_card;
    if (id) {
      if (this.eventItem.type === 'face' || this.eventItem.type === 'body') {
        this.card = (await dataModule.humanCardsModule.getById(id)) || null;
      }
      if (this.eventItem.type === 'car') {
        this.card = (await dataModule.carCardsModule.getById(id)) || null;
      }
    }
  }

  async loadWatchLists() {
    const ids = this.card?.watch_lists;
    if (ids) {
      this.watchLists = await dataModule.watchListsModule.getByIds(ids);
    }
  }

  async mounted() {
    await this.loadCard();
    await this.loadWatchLists();
  }
}
